import { Link } from "react-router-dom";
import "../styles/Notfound.css";

function Notfound() {
  document.body.style.backgroundColor = "#E5E4EF";
  return (
    <div className="Notfound">
      <div className="Middle">
        <h2>404 | Not found!</h2>
        <p>The page you were looking for doesn't exist.</p>
        <Link to="/">Back to Ski studio</Link>
      </div>
    </div>
  );
}

export default Notfound;
